import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-btn",
  "use": "icon-btn-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-btn\"><defs><style type=\"text/css\"></style></defs><path d=\"M821.816 328.808H203.12c-49.072 0-88.192 33.656-88.192 74.6V701.52c0 41.504 39.792 74.6 88.192 74.6h618.688c49.072 0 88.184-33.656 88.184-74.6V403.408c0.008-40.944-39.784-74.6-88.176-74.6z m-1.96 423.496H203.76c-68.36 0-61.888-59.064-61.888-133.152v-131.68c0-73.096-6.472-133.16 61.888-133.16h616.104c68.328 0 61.88 60.064 61.88 133.16v131.688c0 73.064 6.44 133.144-61.888 133.144z\" p-id=\"2616\" /><path d=\"M693.784 460.728H329.816c-40.384 0-36.56 27.696-36.56 61.384v60.72c0 34.144-3.824 61.376 36.56 61.376h363.968c40.384 0 36.576-27.688 36.576-61.376v-60.72c0-33.688 3.808-61.384-36.576-61.384z\" p-id=\"2617\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/btn.svg
// module id = O+kw
// module chunks = 31